ACC.refreshMiniCart = {
  refreshMiniCart: function() {
    /* eslint-disable  no-undef */
    $.get($('.ph-refreshMiniCartUrl').text() + (Math.floor(window.crypto.getRandomValues(new Uint32Array(1)) * 101) * new Date().getTime()), function(result) {
      /* eslint-enable  no-undef */
      $('.minicart_data').html(result);
    });
  }
};
/* Fire Add This sharing button on Click not Hover */
/* eslint-disable  no-implicit-globals*/
/* eslint-disable  no-unused-vars*/
/* eslint-disable  camelcase*/
/* eslint-disable  id-match*/

var addthis_config = {
  ui_click: true
};
/* eslint-enable  id-match*/
/* eslint-enable  camelcase*/
/* eslint-enable  no-unused-vars*/
/* eslint-enable  no-implicit-globals*/

$('.modal').colorbox({
  onComplete: function() {
    ACC.common.refreshScreenReaderBuffer();
  },
  onClosed: function() {
    ACC.common.refreshScreenReaderBuffer();
  }
});

$('#homepage_slider').waitForImages(function() {
  $(this).slideView({
    toolTip: true,
    ttOpacity: 0.6,
    autoPlay: true,
    autoPlayTime: 8000
  });
});

/* ]]>*/

$(document).ready(function() {
  $('.span-4 .jcarousel-skin').jcarousel({
    // Configuration goes here
    vertical: true
  });

  if (document.body.className.match('page-orderConfirmationPage')) {
    var data = document.getElementsByClassName('productinfo'),
        productinfo = '';

    for (var i = 0; i < data.length; i = i + 1) {
      productinfo = productinfo + data.item(i).value;
    }

    var meta = document.createElement('meta');

    meta.name = 'PHILIPS.METRICS.PRODUCTS';
    meta.content = productinfo;
    document.getElementsByTagName('head')[0].appendChild(meta);
    /* eslint-disable  no-undef*/
    /* eslint-disable  no-implicit-globals*/
    /* eslint-disable  camelcase*/
    p_initMetricsProps = function() {
      /* eslint-enable  camelcase*/
      /* eslint-enable  no-implicit-globals*/
      s.currencyCode = 'GBP';
      s.purchaseID = document.getElementsByClassName('ph-ordernum__ordernumber')[0].innerText;
      /* eslint-enable  no-undef*/
    };
  }

  if ($('body').hasClass('ph-page-orderConfirmationPage')) {
    var shopOrderDetails = {
      products: $('.ph-salesTracking').val(),
      orderId: $('.ph-orderId').val(),
      orderValue: $('.ph-orderValue').val(),
      currency: $('.ph-currency').val(),
      orderTax: $('.ph-orderTax').val(),
      orderShipping: $('.ph-orderShipping').val(),
      orderDiscount: $('.ph-orderDiscount').val()
    };

    /* eslint-disable  no-undef*/
    /* eslint-disable  no-implicit-globals*/
    /* eslint-disable  camelcase*/
    p_initMetricsProps = function() {
      /* eslint-enable  camelcase*/
      /* eslint-enable  no-implicit-globals*/
      s.currencyCode = shopOrderDetails.currency;
      s.purchaseID = shopOrderDetails.orderId;
      /* eslint-enable  no-undef*/
    };
  }

  $('select').selectBox();
  ACC.common.refreshSelectBoxArrow();
});

$(window).on('load', function() {
  var scriptTag = '<script type="text/javascript" src="//www.crsc.philips.com/crsc/scripts/s_code_philipsglobal.js"></script>';

  $('#currentStoreId').after(scriptTag);
});
